module.exports = __webpack_public_path__ + "static/images/img_top.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_top.jpg
// module id = YRzu
// module chunks = 1